
const state = () => ({
  /**
   * Open/close report dialog visibility.
   * @type Boolean
   */
  show: false,

  /**
   * Report type.
   * @type String|null
   */
  type: null,
})

const getters = {}

const mutations = {
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
  type (state, v) {
    state.type = v
  },
}

const actions = {
  open ({ commit }, type) {
    commit('type', type)
    commit('show')
  },
  close ({ commit }) {
    commit('hide')
    setTimeout(() => commit('type', null), 600)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
